export default __webpack_public_path__ + "static/media/utiva-logo.7984e231.svg";